import {Form} from '../classes/Form';
import {mapState} from 'vuex';
import axios from "axios";

export default {
    data() {
        return {
            useRegion: false,
            hierarchy: [
                'region',
                'city',
                'street',
                'house',
            ],
            cityOptions: [],
            streetOptions: [],
            houseOptions: [],
            regionOptions: [],
            locationForm: new Form({
                region: {
                    id: '',
                    name: '',
                    type_short: '',
                    zip: '',
                },
                city: {
                    id: '',
                    name: '',
                    type_short: '',
                    zip: '',
                },
                district: {
                    id: '',
                    name: '',
                    type_short: '',
                    zip: '',
                },
                street: {
                    id: '',
                    name: '',
                    type_short: ''
                },
                house: '',
                zip: '',
                flat: '',
            }),
            initialization: {
                form: false,
                city: false,
                street: false,
            },
        };
    },

    created() {
        this.filterRegions('');
    },

    watch: {
        regions(newValue, oldValue) {
            this.filterRegions('');
        }
    },

    methods: {
        getLocationForm() {
            return this.locationForm;
        },

        setLocationFormValue(key, value) {
            return this.getLocationForm()[key] = value;
        },

        initLocationOptions() {
            if (this.getLocationForm().city && this.getLocationForm().city.name) {
                this.initialization.city = true;

                this.searchCity(this.getLocationForm().city.name);
            }
            if (this.getLocationForm().street && this.getLocationForm().street.name) {
                this.initialization.street = true;

                this.searchStreet(this.getLocationForm().street.name);
            }
        },

        getOptionValueById(type, value) {
            return this[type + 'Options']
                ? this[type + 'Options'].find(item => item.id === value)
                : null;
        },

        getOptionValueByName(type, value) {
            return this[type + 'Options']
                ? this[type + 'Options'].find(item => item.label === value)
                : null;
        },

        setRegion(value) {
            let _this = this;
            value = window.firstToUpper(value);
            value = _this.getOptionValueById('region', value);

            _this.getLocationForm().errors.clear('region.name');

            _this.setLocationValue('region', value);

            _this.clearDependent('region');
        },

        setCity(value) {
            if (value && value.length < 1 && !this.optionsInitialized) {
                return;
            }

            let _this = this;

            value = _this.getOptionValueById('city', value);

            _this.getLocationForm().errors.clear('city.name');

            _this.setLocationValue('city', value);

            if (value && value.district) {
                _this.setLocationValue('district', value.district);
            } else {
                _this.setLocationValue('district', null);
            }

            if (value && value.region/* && !_this.getLocationForm().region.id*/) {
                _this.getLocationForm().errors.clear('region.name');

                _this.setLocationValue('region', value.region);
            } else if (value && value.id && ['7700000000000', '7800000000000', '9900000000000'].indexOf(value.id) !== -1) {
                _this.getLocationForm().errors.clear('region.name');

                _this.setLocationValue('region', value);
            }

            _this.clearDependent('city');
        },

        setStreet(value) {
            if (!this.optionsInitialized) {
                return;
            }

            let _this = this;

            _this.getLocationForm().errors.clear('street.name');

            let optionValue = _this.getOptionValueByName('street', value);

            if (optionValue) {
                _this.setLocationValue('street', optionValue);

                _this.clearDependent('street');

                _this.getLocationForm().zip = optionValue && optionValue.zip ? optionValue.zip : '';
            } else {
                _this.setLocationInputValue('street', value);

                if (value === null) {
                    _this.clearDependent('street');
                }
            }
        },

        setHouse(value) {
            if (!this.optionsInitialized) {
                return;
            }

            let _this = this;

            let optionValue = _this.getOptionValueByName('house', value);

            _this.getLocationForm().errors.clear('house');

            _this.getLocationForm().house = optionValue ? optionValue.code : value;

            _this.getLocationForm().zip = optionValue && optionValue.zip ? optionValue.zip : '';
        },

        setLocationValue(type, value) {
            let _this = this;

            _this.setLocationFormValue(type, {
                id: value ? (value.id ? value.id : value.code) : '',
                name: value ? value.name : '',
                type_short: value ? value.typeShort : '',
                guid: value ? value.guid : '',
                zip: value ? value.zip : '',
            });
        },

        setLocationInputValue(type, value) {
            let _this = this;

            _this.setLocationFormValue(type, {
                id: '',
                name: value,
                type_short: '',
            });
        },

        clearDependent(type) {
            let _this = this;

            for (var i in _this.hierarchy) {
                if (_this.hierarchy[i] === type) {
                    break;
                }
            }

            let nextIndex = parseInt(i) + 1;

            if (_this.hierarchy[nextIndex] && _this.getLocationForm().hasOwnProperty(_this.hierarchy[nextIndex])) {
                let methodName = 'set' + _this.hierarchy[nextIndex].charAt(0).toUpperCase() + _this.hierarchy[nextIndex].slice(1);

                _this[methodName](null);

                // clean up options
                _this[_this.hierarchy[nextIndex] + 'Options'] = [];
            }

            _this.getLocationForm().errors.clear('zip');
        },

        search(search, update, requestData, option) {
            const _this = this;

            if (search && search.length) {
                axios.post('/search-location/' + search, requestData)
                    .then(response => {
                        let data = [];
                        if (response.data.data.length) {
                            data = response.data.data;
                        }
                        if (update) {
                            update(() => {
                                _this.setOptions(option, data);
                            })
                        } else {
                            _this.setOptions(option, data);
                        }
                    });
            }
        },

        searchCity(val, update, abort) {
            val = val ? val : this.getLocationForm().city.name;
            val = window.firstToUpper(val);

            if (this.useRegion && this.getLocationForm().region.name) {
                val = this.getLocationForm().region.name + ' ' + val;
            }
            let data = {contentType: 'city', parentId: this.getLocationForm().region?.id};

            this.search(val, update, data, 'city');
        },

        searchStreet(val, update, abort) {
            if (!val) {
                val = this.getLocationForm().street.name;
            }
            val = window.firstToUpper(val);

            if (this.getLocationForm().city.name) {
                if (this.getLocationForm().city.name) {
                    val = this.getLocationForm().city.name + ' ' + val;
                }
                if (this.getLocationForm().region.name) {
                    val = this.getLocationForm().region.name + ' ' + val;
                }
                let data = {contentType: 'street', parentId: this.getLocationForm().city?.id};

                this.search(val, update, data, 'street');
            } else if (update) {
                update(() => {
                });
            }
        },

        searchHouse(val, update, abort) {
            if (this.getLocationForm().street.name) {
                if (this.getLocationForm().street.name) {
                    val = this.getLocationForm().street.name + ' ' + val;
                }
                if (this.getLocationForm().city.name) {
                    val = this.getLocationForm().city.name + ' ' + val;
                }
                if (this.getLocationForm().region.name) {
                    val = this.getLocationForm().region.name + ' ' + val;
                }
                this.search(
                    val,
                    update,
                    {contentType: 'building', parentId: this.getLocationForm().street?.id},
                    'house'
                );
            } else {
                update(() => {
                });
            }
        },

        setOptions(option, data) {
            let _this = this;

            option = option.replace('Options', '');
            let optionsName = option + 'Options';
            let options = [];

            for (let i in data) {
                let value = data[i];

                let id = optionsName === 'houseOptions' ? value.name : value.id;

                if (id) {
                    let optionData = {
                        label: value.typeShort + '. ' + value.name,
                        code: optionsName === 'houseOptions' ? value.name : value.id,
                        id: optionsName === 'houseOptions' ? value.name : value.id,
                        name: value.name,
                        typeShort: value.typeShort,
                        contentType: value.contentType,
                        zip: value.zip,
                        guid: value.guid,
                    };

                    if (value.parents) {
                        let hasParents = false;
                        let district = value.parents.filter(parent => parent.contentType === 'district');

                        if (district.length === 1) {
                            hasParents = true;
                            district = district[0];

                            optionData.label += ', ' + district.name
                                + (district.typeShort ? ' ' + district.typeShort + '.' : '');

                            optionData.district = {
                                id: district.id,
                                name: district.name,
                                typeShort: district.typeShort,
                            };
                        }

                        let region = value.parents.filter(parent => parent.contentType === 'region');

                        if (region.length === 1) {
                            hasParents = true;
                            region = region[0];

                            optionData.region = {
                                id: region.id,
                                name: region.name,
                                typeShort: region.typeShort,
                                guid: region.guid,
                            };

                            optionData.label += ', ' + region.name
                                + (region.typeShort ? ' ' + region.typeShort + '.' : '');
                        }

                        if (!hasParents) {
                            let city = value.parents.filter(parent => parent.contentType === 'city' && parent.id !== this.getLocationForm().city.id);

                            if (city.length) {
                                city = city[0];
                                optionData.label += ', ' + city.typeShort + '. ' + city.name;
                            }
                        }
                    }
                    options.push(optionData);
                }
            }

            Vue.set(this, optionsName, options);

            if (_this.initialization[option]) {
                _this.initialization[option] = false;
            }
        },

        searchRegion(val, update, abort) {
            update(() => this.filterRegions(val));
        },

        filterRegions(value) {
            let regions = this.regions;

            if (!value && this.getLocationForm() && this.getLocationForm().region) {
                value = this.getLocationForm().region.name;
            }

            if (!regions) {
                this.regionOptions = [];

                return;
            }

            if (value !== '') {
                value = value.toLowerCase();

                regions = regions.filter(item => item.name.toLowerCase().indexOf(value) !== -1)
            }

            Vue.set(this, 'regionOptions', regions.map(item => {
                return {
                    code: item.id,
                    label: item.name + (item.typeShort ? ' ' + item.typeShort + '.' : ''),
                    id: item.id,
                    name: item.name,
                    typeShort: item.typeShort
                }
            }));
        },

        formInitialization() {
            let _this = this;

            this.initialization.form = true;

            setTimeout(function () {
                _this.formInitialized();
            }, 500);
        },

        formInitialized() {
            this.initialization.form = false;
        },
    },

    computed: {
        ...mapState('asset', [
            'regions',
        ]),

        regionLabel: function () {
            let region = this.getLocationForm().region;

            return region.name + (region.type_short ? ' ' + region.type_short + '.' : '');
        },

        selectedCity: function () {
            return this.cityOptions.find(item => item.id === this.getLocationForm().city.id);
        },

        selectedStreet: function () {
            return this.streetOptions.find(item => item.id === this.getLocationForm().street.id);
        },

        optionsInitialized() {
            for (let i in this.initialization) {
                if (this.initialization[i]) {
                    return false;
                }
            }

            return true;
        }
    }
};
